:host {
  @include cms-components-host-defaults;
  --cms-text-color: var(--cms-semanticColors-base-strong-text);
}

.infographic-container-inner {
  @include cms-default-grid-container;
}

.infographic-container-inner>* {
  grid-area: var(--cms-default-grid-area);
}

.infographic-img-wrapper {
  position: relative;
  cursor: pointer;
}

.hotspot {
  font-family: var(--cms-brandfont2);
  width: var(--cms-spacing-200);
  height: var(--cms-spacing-200);
  border-radius: var(--cms-border-radius-half);
  background-color: var(--cms-semanticColors-primary-background);
  color: var(--cms-semanticColors-primary-textOnBackground);
  font-weight: var(--cms-base-font-weight-700);
  font-size: var(--cms-font-size-125);
  display: flex;
  justify-content: center;
  align-items: center;
}

.open-overlay-wrapper {
  line-height: px-to-rem(30);
  position: absolute;
  right: var(--cms-spacing-100);
  text-align: right;
  top: var(--cms-spacing-100);
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.details-headline {
  @include  label-font-125;
}

.open-overlay-text {
  background: var(--cms-semanticColors-transparency-medium-background);
  border-radius: var(--cms-border-radius-special);
  display: flex;
  align-items: center;
  height: var(--cms-spacing-200);
  padding-right: var(--cms-spacing-300);
  color: var(--cms-semanticColors-transparency-medium-textOnBackground);
  margin: 0 var(--cms-spacing-100) 0 var(--cms-spacing-025);
  padding-left: var(--cms-spacing-100);
  @include label-font-100;
}

.open-overlay-icon {
  background-color: var(--cms-semanticColors-primary-background);
  border: var(--cms-border-size-xs) solid var(--cms-semanticColors-primary-background);
  border-radius: var(--cms-border-radius-half);
  color: var(--cms-semanticColors-primary-textOnBackground);
  font-family: arial;
  font-size: var(--cms-spacing-200);
  height: var(--cms-spacing-200);
  line-height: var(--cms-spacing-200);
  position: absolute;
  right: var(--cms-spacing-075);
  text-align: center;
  top: 0;
  width: var(--cms-spacing-200);
  display: flex;
  align-items: center;
  justify-content: center;
}

.hotspot-wrapper {
  vertical-align: top;
  display: inline-block;
  margin-right: var(--cms-spacing-100);
}

.details-content {
  --cms-default-grid-area: auto / 2 / auto / span 10;
  color: var(--cms-text-color);
  display: flex;
  flex-direction: column;
  gap: var(--cms-spacing-050);
}

.details-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--cms-spacing-100);
}

.hotspot-details {
  display: flex;

  >* {
    grid-area: var(--cms-default-grid-area);
  }
}

.details-text {
  padding-right: var(--cms-spacing-300);
}

.details-text p {
  margin: 0;
}

.details-text a {
  --cms-theme-text-color: var(--cms-semanticColors-base-strong-text);
  @include cms-anchor-base-font;
}

@include media-width($breakpoint-sm) {

  .two-thirds {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }

  .hotspot-wrapper {
    margin: 0 var(--cms-spacing-100);
  }
}